import { createAction } from '@reduxjs/toolkit';

import { getFailurePayloadCreator, getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type {
  CreateWatchlistInput,
  DeleteWatchlistInput,
  SpendingWatchlistProps,
  WatchlistCreate,
  WatchlistUpdate,
} from './spendingWatchlistTypes';

const watchlistPayloadCreator = getPayloadCreator<SpendingWatchlistProps>();
const unknownFailurePayloadCreator = getFailurePayloadCreator<unknown>();

export const createWatchList = createAction('CREATE_WATCHLIST', getPayloadCreator<CreateWatchlistInput>());
export const createWatchListFailure = createAction('CREATE_WATCHLIST_FAILURE', unknownFailurePayloadCreator);

export const deleteWatchList = createAction('DELETE_WATCHLIST', getPayloadCreator<DeleteWatchlistInput>());

export const getSpendingWatchLists = createAction('GET_SPENDING_WATCH_LISTS', getPayloadCreator());
export const getSpendingWatchListsInitial = createAction('GET_SPENDING_WATCH_LISTS_INITIAL', getPayloadCreator());
export const getSpendingWatchListsSuccess = createAction(
  'GET_SPENDING_WATCH_LISTS_SUCCESS',
  getPayloadCreator<QcsSyncResourcesPayload<SpendingWatchlistProps>>(),
);
export const getSpendingWatchListsFailure = createAction(
  'GET_SPENDING_WATCH_LISTS_FAILURE',
  unknownFailurePayloadCreator,
);

export const createSpendingWatchList = createAction('CREATE_SPENDING_WATCH_LIST', getPayloadCreator<WatchlistCreate>());
export const createSpendingWatchListSuccess = createAction(
  'CREATE_SPENDING_WATCH_LIST_SUCCESS',
  watchlistPayloadCreator,
);
export const createSpendingWatchListFailure = createAction(
  'CREATE_SPENDING_WATCH_LIST_FAILURE',
  unknownFailurePayloadCreator,
);

export const updateSpendingWatchList = createAction('UPDATE_SPENDING_WATCH_LIST', getPayloadCreator<WatchlistUpdate>());
export const updateSpendingWatchListSuccess = createAction(
  'UPDATE_SPENDING_WATCH_LIST_SUCCESS',
  watchlistPayloadCreator,
);
export const updateSpendingWatchListFailure = createAction(
  'UPDATE_SPENDING_WATCH_LIST_FAILURE',
  unknownFailurePayloadCreator,
);

export const deleteSpendingWatchList = createAction('DELETE_SPENDING_WATCH_LIST', getPayloadCreator<WatchlistUpdate>());
export const deleteSpendingWatchListSuccess = createAction(
  'DELETE_SPENDING_WATCH_LIST_SUCCESS',
  watchlistPayloadCreator,
);
export const deleteSpendingWatchListFailure = createAction(
  'DELETE_SPENDING_WATCH_LIST_FAILURE',
  unknownFailurePayloadCreator,
);
